import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LanguageDialogComponent } from './language-dialog/language-dialog.component';
import { DesktopService } from '../../../services/desktop.service';
import { InformationDialogComponent } from './information-dialog/information-dialog.component';
import { Router } from '@angular/router';
import { SyncConfirmComponent } from './sync-confirm/sync-confirm.component';

@Component({
  selector: 'mwo-settings-dialog',
  templateUrl: './settings-dialog.component.html',
  styleUrls: ['./settings-dialog.component.scss']
})
export class SettingsDialogComponent implements OnInit {

  constructor(private dialog: MatDialog, private dialogRef: MatDialogRef<SettingsDialogComponent>, private _desktopService: DesktopService, private _router: Router) {
  }

  ngOnInit(): void {
  }

  openLanguageDialog() {
    this.dialog.open(LanguageDialogComponent);
    this.dialogRef.close();
  }

  openInfoDialog() {
    this.dialogRef.close();
    this.dialog.open(InformationDialogComponent);
  }

  sendSyncRequest() {
    this.dialog.open(SyncConfirmComponent, {
      width: '250px', height: '200px',
    });
    this.dialogRef.close();
  }

  logOut() {
    this._desktopService.logOut().subscribe(() => {
      // this.snackBar.open('Logout', 'Close', {duration: 3000});
    });
  }

  openBlacklist() {
    this._router.navigate(['/blacklist']).then(() => {
      this.dialogRef.close();
    });
  }

  openHistory() {
    this._router.navigate(['/history']).then(() => {
      this.dialogRef.close();
    });
  }
}
